(() => {
  'use strict';
  function initialize(root = document) {
    root.querySelectorAll('[data-garden-blog-trigger]').forEach(trigger => {
      if (trigger.dataset.gardenReady) return;
      const panel = document.getElementById(trigger.getAttribute('popovertarget'));
      if (!panel) return;
      trigger.dataset.gardenReady = 'true';
      // Native popovers keep focus order and escape overflow-clipped mobile menus.
      if (typeof panel.showPopover !== 'function') {
        panel.removeAttribute('popover');
        panel.style.position = 'static';
        trigger.addEventListener('click', () => {
          panel.hidden = !panel.hidden;
          trigger.setAttribute('aria-expanded', String(!panel.hidden));
        });
        panel.hidden = true;
        return;
      }
      const position = () => {
        const rect = trigger.getBoundingClientRect();
        const width = panel.offsetWidth;
        const height = panel.offsetHeight;
        const above = trigger.hasAttribute('data-open-above');
        const left = Math.max(12, Math.min(rect.left + (rect.width - width) / 2, window.innerWidth - width - 12));
        const desiredTop = above ? rect.top - height - 8 : rect.bottom + 8;
        panel.style.left = `${left}px`;
        panel.style.top = `${Math.max(12, Math.min(desiredTop, window.innerHeight - height - 12))}px`;
      };
      panel.addEventListener('toggle', event => {
        const open = event.newState === 'open';
        trigger.setAttribute('aria-expanded', String(open));
        if (open) position();
      });
      const close = event => {
        if (event && panel.contains(event.target)) return;
        if (panel.matches(':popover-open')) panel.hidePopover();
      };
      window.addEventListener('resize', close, {passive: true});
      panel.addEventListener('click', event => { if (event.target.closest('a')) close(); });
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        panel.showPopover();
        position();
        panel.querySelector('a').focus();
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
